import { z } from "zod";

export const Level = z.object({
  id: z.number().int().positive(),
  code: z.string().min(1).max(80),
  label: z.string().min(1).max(200),
  numericValue: z.number().int().min(1).max(10),
  sortOrder: z.number().int().nonnegative(),
  createdAt: z.number().int(),
  updatedAt: z.number().int(),
});
export type Level = z.infer<typeof Level>;

export const LevelCreate = z.object({
  code: z.string().min(1).max(80).regex(/^[a-z0-9_-]+$/),
  label: z.string().min(1).max(200),
  numericValue: z.number().int().min(1).max(10),
  sortOrder: z.number().int().nonnegative(),
});
export type LevelCreate = z.infer<typeof LevelCreate>;

export const LevelUpdate = LevelCreate.partial();
export type LevelUpdate = z.infer<typeof LevelUpdate>;
